'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { differenceInCalendarMonths, startOfMonth } from 'date-fns';
import { useLayoutEffect, useRef } from 'react';
import { fr } from 'react-day-picker/locale';
import { Calendar } from './calendar';
// Monday-first, matching the fr locale RDP renders.
const WEEKDAYS = ['lu', 'ma', 'me', 'je', 've', 'sa', 'di'];
/**
 * Mobile-first calendar: a tall scrollable stack of months (12 by default) with the
 * paging chevrons removed, a single sticky weekday header, and auto-scroll to the
 * current selection on open. Lives inside an `overflow-y-auto` container (the
 * `FullScreenOverlay` body). Desktop keeps `DualCalendar`.
 */
export function MobileScrollCalendar(props) {
    const { disabled, endMonth, header } = props;
    const rootRef = useRef(null);
    const firstMonth = startOfMonth(new Date());
    // Avec une borne haute, la pile s'arrête exactement au mois qui la contient.
    const numberOfMonths = props.numberOfMonths ??
        (endMonth ? differenceInCalendarMonths(endMonth, firstMonth) + 1 : 12);
    useLayoutEffect(() => {
        const selectedDay = rootRef.current?.querySelector('[data-range-start="true"], [data-selected-single="true"]');
        selectedDay?.scrollIntoView({ block: 'center' });
    }, []);
    const commonProps = {
        className: 'p-0',
        // Hide RDP's per-month weekday rows (we render one sticky header) and the
        // nav chevrons (the user scrolls instead). Force the month grid to be a pure
        // flexbox (table -> flex, tbody -> flex): mobile WebKit/Blink don't size a
        // <table> whose <tr> rows are display:flex, which made days overflow and the
        // month captions float mid-grid.
        classNames: {
            month_grid: 'flex w-full flex-col',
            months: 'relative flex flex-col gap-8',
            nav: 'hidden',
            weekdays: 'hidden',
            weeks: 'flex w-full flex-col',
        },
        defaultMonth: firstMonth,
        disabled,
        endMonth,
        locale: fr,
        numberOfMonths,
        // No outside days, so stacked months don't show duplicate-looking dates.
        showOutsideDays: false,
        startMonth: firstMonth,
    };
    return (_jsxs("div", { ref: rootRef, children: [_jsxs("div", { className: "bg-background sticky top-0 z-10 px-4 pt-2 pb-1", children: [header && _jsx("div", { className: "pb-3", children: header }), _jsx("div", { className: "flex", children: WEEKDAYS.map((day) => (_jsx("div", { className: "text-muted-foreground flex-1 text-center text-[0.8rem]", children: day }, day))) })] }), _jsx("div", { className: "px-4 pb-4 [&_[data-slot=calendar]]:w-full", children: props.mode === 'single' ? (_jsx(Calendar, { ...commonProps, mode: "single", onSelect: props.onSelect, selected: props.selected })) : (_jsx(Calendar, { ...commonProps, mode: "range", onSelect: props.onSelect, required: true, selected: props.selected })) })] }));
}
